import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';
import {goToPage, reportAnalytics} from '../../fundialSlice';
import PlaylistExceedError from '../PlaylistExceedError/PlaylistExceedError'
import SongExist from '../SongExist/SongExist';

const subscriberError = (props) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  useEffect(() => {
    switch (props.errorType) {
      case 'SUBSCRIBER_ERROR':
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_Error_NotInServies",
          eventLabel: "",
        });
        setTitle('המנוי שבחרת אינו יכול להירשם לשירות זה');
        setContent(`לפתיחת המנוי לרכישת תוכן ניתן לפנות ל- ${window.Config.technicalSupportPhone}`);
        break;
      case 'SONG_ERROR':
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_Error_NotInstall",
          eventLabel: "",
        });
        setTitle('מצטערים, לא הצלחנו להתקין את השיר למנוי');
        setContent(`למידע נוסף ורישום לשרות, ניתן לפנות ל- ${window.Config.technicalSupportPhone}`);
        break;
      case 'ADD_CONTACT_ERROR':
        setTitle('מצטערים, לא הצלחנו לשייך את השיר לאיש הקשר שבחרתם');
        setContent(`יש לוודא כי המספר רשום בצורה תקני, למידע נוסף ורישום לשרות, ניתן לפנות ל- ${window.Config.technicalSupportPhone}`);
        break;
      case 'NOT_FOUND_SUBSCRIBERS':
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_Error_NoCellular",
          eventLabel: "",
        });
        setTitle('חיפשנו חיפשנו ולא מצאנו מנוי סלולר בחשבון שלכם ');
        setContent('שירות המתנה נעימה זמין עבור מנויי סלולר בלבד');
        break;
      case 'SONG_EXIST':
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_Error_Song AllreadyExist",
          eventLabel: "",
        });
        break;
      case 'PLAYLIST_EXCEED_ERROR':
          props.reportAnalytics({
            eventCategory: 'fundial',
            eventAction: "HN_Error_MagFull",
            eventLabel: "",
          });
        break;
      case 'GENERAL':
      default:
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_Error_General",
          eventLabel: "",
        });
        setTitle('אירעה שגיאה כללית');
        setContent(`למידע נוסף ורישום לשרות, ניתן לפנות ל- ${window.Config.technicalSupportPhone}`);
        break;
    }
  }, [props.errorType]);

  function onClickBtn() {
    props.goToPage({page: 'lobbyPage'});
  }

  function view(){
    switch(props.errorType){
      case "PLAYLIST_EXCEED_ERROR":
        return <PlaylistExceedError/>;
      case "SONG_EXIST":
        return <SongExist selectAnotherSong={() => {props.goToPage({page: 'catalogPage'})}}/>
      default :
        return (<section className='subscriber-error'>
          <div className='title'>
            <Image src={require('./images/error-icon.svg')} />
            <p>{title}</p>
          </div>
          <p className='text'>{content}</p>
          <BtnWhite text='סגור' onclick={onClickBtn} />
      </section>)

    }
  }

  return (view());
};

const mapStateToProps = (state) => {
  return {
    errorType: state.fundialPage.pages.errorPage.errorType,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(subscriberError);
